import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Modal from '@mui/material/Modal'
import { useForm } from 'react-hook-form'
import { makePostRequest } from 'utils/api'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 350,
  bgcolor: 'background.paper',
  borderRadius: '10px',
  boxShadow: 24,
  p: 4,
}

export default function UserPassword() {
  const [open, setOpen] = React.useState(false)
  const [invalidPassword, setInvalidPassword] = React.useState(false)
  const [notMatch, setNotMatch] = React.useState(false)
  const [upassword, setUpassword] = React.useState({
    password: '',
    newPassword: '',
    confirmPassword: '',
  })
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const checkMatch = (e) => {
    let pass = e.target.value
    if (e.target.name === 'np' && pass) {
      if (pass === upassword.confirmPassword) {
        setNotMatch(false)
      } else {
        setNotMatch(true)
      }
    }
    if (e.target.name === 'cp' && pass) {
      if (pass === upassword.newPassword) {
        setNotMatch(false)
      } else {
        setNotMatch(true)
      }
    }
  }
  const { handleSubmit, control, setValue, reset, getValues } = useForm({
    defaultValues: {
      // // Marque : params[0].Marque,
    },
  })
  const onSubmit = async (data) => {
    const response = await makePostRequest('/api/user/update-password/', upassword, {}, true)
    if (response.status === 200) {
      if (response.data.status) {
        setInvalidPassword(false)
        setOpen(false)
      } else {
        setInvalidPassword(true)
      }
    }
  }
  return (
    <div>
      <Button onClick={handleOpen} sx={{ textTransform: 'none', textDecoration: 'underline' }}>
        modifier
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            display={'flex'}
            justifyContent={'center'}
            flexDirection={'column'}
            alignItems={'center'}
          >
            <form onSubmit={onSubmit} style={{ height: '100%' }}>
              <Box mb={2} display={'flex'} width={'100%'} flexDirection={'column'}>
                <label>Indiquer mot de passe actuel</label>
                <input
                  style={{ width: '100%' }}
                  value={upassword.password}
                  onChange={(e) => {
                    setUpassword((pre) => ({ ...pre, password: e.target.value }))
                  }}
                  type="password"
                  required
                />
                {invalidPassword && (
                  <Box component={'p'} color={'red'}>
                    mauvais mot de passe
                  </Box>
                )}
              </Box>
              <Box mb={2} display={'flex'} style={{ width: '100%' }} flexDirection={'column'}>
                <label>Définir nouveau mot de passe</label>
                <input
                  style={{ width: '100%' }}
                  value={upassword.newPassword}
                  onChange={(e) => {
                    setUpassword((pre) => ({ ...pre, newPassword: e.target.value }))
                    checkMatch(e)
                  }}
                  type="password"
                  name="np"
                  required
                />
              </Box>
              <Box mb={2} display={'flex'} width={'100%'} flexDirection={'column'}>
                <label>Confirmer nouveau mot de passe</label>
                <input
                  style={{ width: '100%' }}
                  value={upassword.confirmPassword}
                  onChange={(e) => {
                    setUpassword((pre) => ({ ...pre, confirmPassword: e.target.value }))
                    checkMatch(e)
                  }}
                  type="password"
                  name="cp"
                  required
                />
                {notMatch && (
                  <Box component={'p'} color={'red'}>
                    le mot de passe ne correspond pas
                  </Box>
                )}
              </Box>
              <Box mb={2} display={'flex'} width={'100%'} flexDirection={'column'}>
                <Button type="submit">Update</Button>
              </Box>
            </form>
          </Box>
        </Box>
      </Modal>
    </div>
  )
}
